import { action } from 'satcheljs';

export const updateSelectedCalendars = action(
    'UPDATE_SELECTED_CALENDARS',
    (calendarIds: string[], primarySmtpAddress: string) => ({ calendarIds, primarySmtpAddress })
);

export const addSelectedCalendar = action(
    'ADD_SELECTED_CALENDAR',
    (calendarId: string, primarySmtpAddress: string) => ({ calendarId, primarySmtpAddress })
);

export const initializeSelectedCalendars = action(
    'INITIALIZE_SELECTED_CALENDARS',
    (calendarIds: string[], primarySmtpAddress: string) => ({ calendarIds, primarySmtpAddress })
);

export const selectedCalendarsUpdated = action(
    'SELECTED_CALENDARS_UPDATED',
    (calendarIds: string[], primarySmtpAddress: string) => ({ calendarIds, primarySmtpAddress })
);
